import React from "react";
import Input from "../FormComponents/Input";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import FieldSelectorFromPopup from "../BuilderComponents/FieldSelectorFromPopup";
import Label from "../FormComponents/Label";

const modeType = [
  { name: "Array", id: "array" },
  { name: "Object", id: "object" },
  { name: "Key-Value", id: "key_value" },
  { name: "Raw Key-Value", id: "raw_key_value" }
];

const EditJsonToTable = ({ editElementData, setEditElementData, tableId, device, tableType }) => {
  const { columns = [], columns_path = "" } = editElementData;

  const handleColumnChange = (index, field, value) => {
    const newColumns = [...columns];
    newColumns[index] = { ...newColumns[index], [field]: value };
    setEditElementData({ ...editElementData, columns: newColumns });
  };

  const handleColumnsPathChange = (value) => {
    setEditElementData({ ...editElementData, columns_path: value });
  };

  const addNewColumn = () => {
    const newColumn = {
      id: Date.now().toString(),
      field_type: "varchar",
      header_name: "",
      placeholder: "",
      value_path: ""
    };
    setEditElementData({
      ...editElementData,
      columns: [...columns, newColumn]
    });
  };

  const deleteColumn = (index) => {
    const newColumns = [...columns];
    newColumns.splice(index, 1);
    setEditElementData({ ...editElementData, columns: newColumns });
  };
  return (
    <div className="flex_column gap_2">
      <Label>Select Field</Label>
      <FieldSelectorFromPopup
        label="Select Field"
        tableId={tableId}
        device={device}
        tableType={tableType}
        onSelect={(fieldObj) => setEditElementData({ ...editElementData, json_field: fieldObj?.id })}
        fieldId={editElementData?.json_field}
      />
      <SingleSelectBox
        label="Mode"
        options={modeType}
        selectedData={editElementData.mode}
        onChange={(value) => setEditElementData({ ...editElementData, mode: value.id })}
      />
      <Input
        label={editElementData.mode === "array" ? "Enter Array Path" : "Enter Object Path"}
        value={columns_path}
        onChange={(e) => handleColumnsPathChange(e.target.value)}
        placeholder="Enter columns path"
      />
      {editElementData.mode !== "raw_key_value" && (
        <div className="border_full p_2 border_radius_small">
          <div className="d_flex items_center justify_between mb_2">
            <p className="builder_label">Columns</p>
            {/* Add Column Button */}
            <ButtonActionIcon
              type="add"
              size="sm"
              onClick={addNewColumn}
              title="Add Column"
              className="add_column_btn"
            />
          </div>
          {columns.length === 0 && (
            <p style={{ fontStyle: "italic" }} className="d_flex items_center justify_center w_100">
              Add New Columns
            </p>
          )}
          <div className="border_radius_medium">
            {columns.map((col, index) => (
              <div key={col.id} className="p_2 mb_3 border_full border_radius_small " style={{ width: "500px" }}>
                <div className="d_flex justify_between items_center w_100 mb_1">
                  <p className="builder_label">{col?.header_name || "Header Name"}</p>
                  <ButtonActionIcon
                    type="delete"
                    size="sm"
                    onClick={() => deleteColumn(index)}
                    title="Delete Column"
                    className="delete_column_btn"
                  />
                </div>
                <div className="flex_column gap_3">
                  <div className="d_flex gap_2">
                    <SingleSelectBox
                      label="Field Type"
                      options={[
                        { id: "varchar", name: "varchar" },
                        { id: "int", name: "int" },
                        { id: "date", name: "Date" },
                        { id: "time", name: "Time" },
                        { id: "datetime", name: "Datetime" },
                        { id: "file", name: "File" },
                        { id: "array", name: "Array" }
                      ]}
                      valueKey="id"
                      labelKey="name"
                      selectedData={col.field_type}
                      onChange={(option) => handleColumnChange(index, "field_type", option?.id || "")}
                      placeholder="Select field type"
                    />

                    {/* Header Name */}
                    <Input
                      label="Header Name"
                      value={col.header_name}
                      onChange={(e) => handleColumnChange(index, "header_name", e.target.value)}
                      placeholder="Enter header name"
                    />
                  </div>

                  <div className="d_flex gap_2">
                    {/* Placeholder */}
                    <Input
                      label="Placeholder"
                      value={col.placeholder}
                      onChange={(e) => handleColumnChange(index, "placeholder", e.target.value)}
                      placeholder="Enter placeholder"
                    />

                    {/* Value Path */}
                    <Input
                      label="Value Path"
                      value={col.value_path}
                      onChange={(e) => handleColumnChange(index, "value_path", e.target.value)}
                      placeholder="Enter value path"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditJsonToTable;
